import { useUser } from 'contexts/UserContext'
import { menuItems } from 'data/menuItems'
import PropTypes from 'prop-types'
import { useLocation } from 'wouter'
import MenuItems from './MenuItems'

export default function Menu({ isSidebarOpen, setIsSidebarOpen = () => {} }) {
  const { user } = useUser()
  const [location] = useLocation()

  return (
    menuItems &&
    menuItems
      .filter((item) => item.roles?.includes(user.role_id))
      .map((item, index) => {
        return (
          <MenuItems
            key={index}
            item={item}
            user={user}
            location={location}
            isSidebarOpen={isSidebarOpen}
            setIsSidebarOpen={setIsSidebarOpen}
          />
        )
      })
  )
}

Menu.propTypes = {
  isSidebarOpen: PropTypes.bool,
  setIsSidebarOpen: PropTypes.func
}
